/**
 * NoShowFields — campi per lo stage `no_show` (rischedula o archivia).
 * ★ Fase 59.P2 — estratto da StageTransitionModal.jsx. Comportamento invariato.
 */
import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import { AlertCircle } from 'lucide-react';
import { ARCHIVE_REASONS } from './constants';
import i18n from '../../i18n';

export function NoShowFields({ form, set }) {
  return (
    <div className="space-y-4">
      <div className="rounded-md bg-rose-50 border border-rose-200 p-3 text-xs text-rose-900 flex items-start gap-2">
        <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" />
        <span>{i18n.t('stageTransition.noShowIntro', 'Il cliente non si è presentato. Vuoi rischedulare o archiviare?')}</span>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={() => set('no_show_action', 'reschedule')}
          data-testid="noshow-reschedule-btn"
          className={`rounded-md border p-3 text-left transition-colors ${
            form.no_show_action === 'reschedule'
              ? 'border-cyan-600 bg-cyan-50'
              : 'border-border hover:border-cyan-400'
          }`}
        >
          <div className="text-sm font-medium">📅 {i18n.t('stageTransition.reschedule', 'Rischedula')}</div>
          <div className="text-[10px] text-muted-foreground mt-0.5">{i18n.t('stageTransition.rescheduleHint', 'Riporta a "Appuntamento fissato"')}</div>
        </button>
        <button
          type="button"
          onClick={() => set('no_show_action', 'archive')}
          data-testid="noshow-archive-btn"
          className={`rounded-md border p-3 text-left transition-colors ${
            form.no_show_action === 'archive'
              ? 'border-red-600 bg-red-50'
              : 'border-border hover:border-red-400'
          }`}
        >
          <div className="text-sm font-medium">📁 {i18n.t('stageTransition.archiveBtn', 'Archivia')}</div>
          <div className="text-[10px] text-muted-foreground mt-0.5">{i18n.t('stageTransition.archiveHint', 'Marca come perso (con motivo)')}</div>
        </button>
      </div>

      {form.no_show_action === 'reschedule' && (
        <div>
          <Label className="text-xs uppercase tracking-wide">{i18n.t('stageTransition.newApptDate', 'Nuova data appuntamento')} *</Label>
          <Input
            type="datetime-local"
            value={form.no_show_reschedule_at}
            onChange={(e) => set('no_show_reschedule_at', e.target.value)}
            data-testid="noshow-reschedule-at"
            className="mt-1"
          />
        </div>
      )}

      {form.no_show_action === 'archive' && (
        <div className="space-y-2">
          <Label className="text-xs uppercase tracking-wide">{i18n.t('stageTransition.archiveReason', 'Motivo archivio')} *</Label>
          <Select value={form.no_show_archive_reason} onValueChange={(v) => set('no_show_archive_reason', v)}>
            <SelectTrigger data-testid="noshow-archive-reason-select" className="mt-1">
              <SelectValue placeholder={i18n.t('stageTransition.selectReasonPh', 'Seleziona un motivo…')} />
            </SelectTrigger>
            <SelectContent>
              {ARCHIVE_REASONS.map((r) => (
                <SelectItem key={r} value={r}>{r}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Textarea
            rows={2}
            placeholder={i18n.t('stageTransition.extraNotesPh', 'Note aggiuntive (opzionali)…')}
            value={form.no_show_archive_note}
            onChange={(e) => set('no_show_archive_note', e.target.value)}
            data-testid="noshow-archive-note"
            className="mt-1"
          />
        </div>
      )}
    </div>
  );
}
